// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.mainhome {
  position: relative;
  }
.overlay {
  position: absolute;
  top: 17%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
  margin: 0;
  font-family: 'Lato', sans-serif;
  /* z-index: 1; */
}
.a-enter-vr-button:hover {
  background-color: gray !important;
  opacity: 1 !important;
}
.grid-container {
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  padding-top: 50px;
}
.grid-item-label {
  text-align: right;
  padding-right: 5%;
}
.grid-item-button {
  text-align: left;
}
.grid-item-button {
  align-items: center;
}
#tokButton {
  font-size: 18px;
  padding: 10px;
  background-color: #995A05;
  color: white;
}
.alert {
  text-align: center;
  color: red;
  padding-top: 25px;
  font-size: 25px;
}
.arrow-container {
  position: relative;
  display: inline-block;
}
.arrow-down {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 30px solid #fff;
  position: relative;
  animation: arrowAnimation 1s infinite alternate;
}

@keyframes arrowAnimation {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(10px);
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB;AACF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.mainhome {\n  position: relative;\n  }\n.overlay {\n  position: absolute;\n  top: 17%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #fff;\n  text-align: center;\n  margin: 0;\n  font-family: 'Lato', sans-serif;\n  /* z-index: 1; */\n}\n.a-enter-vr-button:hover {\n  background-color: gray !important;\n  opacity: 1 !important;\n}\n.grid-container {\n  display: grid;\n  grid-template-columns: auto auto;\n  align-items: center;\n  padding-top: 50px;\n}\n.grid-item-label {\n  text-align: right;\n  padding-right: 5%;\n}\n.grid-item-button {\n  text-align: left;\n}\n.grid-item-button {\n  align-items: center;\n}\n#tokButton {\n  font-size: 18px;\n  padding: 10px;\n  background-color: #995A05;\n  color: white;\n}\n.alert {\n  text-align: center;\n  color: red;\n  padding-top: 25px;\n  font-size: 25px;\n}\n.arrow-container {\n  position: relative;\n  display: inline-block;\n}\n.arrow-down {\n  width: 0;\n  height: 0;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n  border-top: 30px solid #fff;\n  position: relative;\n  animation: arrowAnimation 1s infinite alternate;\n}\n\n@keyframes arrowAnimation {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(10px);\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
